// Open sidebar on button click
jQuery(document).ready(function ($) {
	
	$('.sidebar .show-more').on('click', function() {
		if ($(this).hasClass('active')) {
			$('.sidebar').removeClass('open');
			$(this).removeClass('active');
		} else {
			$('.sidebar').addClass('open');
			$(this).addClass('active');
		}
    });
  
});
